<section class="page">
  <header class="page-header">
    <div>
      <h1>Career Challenges</h1>
      <p>Manage role-scoped challenges, sponsors, teams, and submissions.</p>
    </div>
    <div class="header-actions">
      <a mat-stroked-button routerLink="/admin/career-challenges/automation">Automation settings</a>
      <button mat-flat-button color="primary" type="button" (click)="startCreate()">Create challenge</button>
    </div>
  </header>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <mat-card class="block">
    <form class="filters" [formGroup]="filterForm" (ngSubmit)="load()">
      <mat-form-field appearance="outline">
        <mat-label>Status</mat-label>
        <mat-select formControlName="status">
          <mat-option value="">All</mat-option>
          <mat-option *ngFor="let s of statuses" [value]="s">{{ s }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Search</mat-label>
        <input matInput formControlName="searchText" />
      </mat-form-field>
      <button mat-stroked-button type="submit" [disabled]="loading">Filter</button>
    </form>

    <table mat-table [dataSource]="items" class="table">
      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef>Title</th>
        <td mat-cell *matCellDef="let row">{{ row.title }}</td>
      </ng-container>
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let row">{{ row.type }}</td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let row">{{ row.status }}</td>
      </ng-container>
      <ng-container matColumnDef="slug">
        <th mat-header-cell *matHeaderCellDef>Slug</th>
        <td mat-cell *matCellDef="let row">{{ row.slug }}</td>
      </ng-container>
      <ng-container matColumnDef="website">
        <th mat-header-cell *matHeaderCellDef>Website</th>
        <td mat-cell *matCellDef="let row">{{ row.showOnWebsite ? 'Yes' : 'No' }}</td>
      </ng-container>
      <ng-container matColumnDef="participants">
        <th mat-header-cell *matHeaderCellDef>Participants</th>
        <td mat-cell *matCellDef="let row"><a mat-button [routerLink]="['/admin/career-challenges', row.id, 'participants']" [attr.aria-label]="'View participants for ' + row.title">{{ row.registrationCount ?? 0 }}</a></td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <button mat-button type="button" (click)="open(row.id)">Open</button>
          <button mat-button type="button" (click)="copy(row)" [disabled]="copyingId === row.id">Copy</button>
          <button
            *ngIf="row.status === 'draft'"
            mat-button
            color="warn"
            type="button"
            (click)="deleteDraft(row)"
            [disabled]="deletingId === row.id"
          >
            Delete
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr mat-row *matRowDef="let row; columns: columns"></tr>
    </table>

    <p *ngIf="!loading && items.length === 0" class="empty">No career challenges yet.</p>

    <mat-paginator
      [length]="totalCount"
      [pageIndex]="filterForm.controls.page.value - 1"
      [pageSize]="filterForm.controls.pageSize.value"
      [pageSizeOptions]="[10, 20, 50]"
      (page)="onPage($event)"
    ></mat-paginator>
  </mat-card>
</section>
